// custom mapping to relate how waiver web deals with
// "language" codes versus how the backend does
export function ConvertLangCode(language) {
  switch (language) {
    case 'en':
      return 'en-us'
    case 'es':
      return 'es-mx'
    case 'fr_CA':
      return 'fr-ca'
    default:
      return language
  }
}
